export interface FilterConditionPayload {
  n: string;
  o: string;
  v: any;
}

export interface QueryPayload {
  q?: string;
  qn?: string;
  filters: FilterConditionPayload[];
}

export function buildModuleQueryFromFilterModel(sdata: any, model: any): QueryPayload {
  const allowedFields = (sdata?.menu?.mnu || []).map((m: any) => m.v);
  const defaultField = model?.defaultField || sdata?.menu?.def || allowedFields[0];

  const filters = (model?.conditions || [])
    .filter((c: any) => c && c.field && allowedFields.includes(c.field))
    .map((c: any) => ({
      n: c.field,
      o: c.operator || "contains",
      v: c.value,
    }))
    .filter((c: any) => c.v !== undefined && c.v !== null && String(c.v) !== "");

  return {
    q: model?.search || "",
    qn: defaultField,
    filters,
  };
}
